// Function to generate a deterministic random number based on a seed
const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

// Get the current day number (0-364) to use as a seed
const getDayNumber = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
};

// Generate a daily random change that remains consistent throughout the day
export const getDailyRandomChange = (id) => {
  const dayNumber = getDayNumber();
  const seed = dayNumber + id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  
  // Generate a number between -50 and +50
  const change = (seededRandom(seed) * 100) - 50;
  
  // Add some volatility based on the hour
  const hour = new Date().getHours();
  const hourSeed = seededRandom(seed + hour);
  const hourlyVolatility = (hourSeed * 10) - 5; // ±5% hourly variation
  
  return Number((change + hourlyVolatility).toFixed(2));
};

// Get the current price with 24h change applied
export const getCurrentPrice = (basePrice, id) => {
  const change = getDailyRandomChange(id);
  const multiplier = 1 + (change / 100);
  return Number((basePrice * multiplier).toFixed(3));
};
